export default __webpack_public_path__ + "static/media/gaxon.09f6e1a5.svg";